// set current selected matrix level
export const setCurrentLevel = (state, currentLevel) => {
    state.levels.currentLevel = currentLevel;
};
// set current selected rule
export const setCurrentRule = (state, currentRule) => {
    state.currentRule = currentRule;
};
// set display rule testing
export const setShowRuleTesting = (state, data) => {
    state.showRuleTesting = data;
};
// set display instance table view in rule testing
export const setShowInstanceTable = (state, data) => {
    state.showInstanceTable = data;
};
// rules tested replay
export const testedRules = (state, data) => {
    state.testedRules = data;
};
// backToDiagramVariable
export const setBackToDiagram = (state, data) => {
    state.backToDiagram = data;
};
export const setTestAllRules = (state, data) => {
    state.testAllRules = data;
};
export const setSelectedCondition = (state, data) => {
    state.selectedCondition = data;
};
